/*************************
 * Header
 ************************/
export default function mainHeader(etoroTracking) {
    let lastScrollY = 0;
    let scrollPosition = 0;


    if (window.scrollY > 1) {
        document.body.classList.add('stick-header');
    }

    window.addEventListener('scroll', function() {
        const scrollDelta = 100;
        const scrollDirection = (lastScrollY > window.scrollY) ? 'up' : 'down';
        lastScrollY = window.scrollY;

        if ( scrollDirection === 'up' &&  scrollPosition - window.scrollY > scrollDelta ) {
            document.body.dataset.scrollDirection = 'up';
            scrollPosition = window.scrollY;
        }

        if ( scrollDirection === 'down' &&   window.scrollY - scrollPosition > scrollDelta ) {
            document.body.dataset.scrollDirection = 'down';
            scrollPosition = window.scrollY;
        }

        if (window.scrollY > 1) {
            document.body.classList.add('stick-header');
        } else {
            document.body.classList.remove('stick-header');
        }
    });

    /*====================================  Top Navigation - tracking  ====================================*/
    const menuLinks = document.querySelectorAll('#e-header a');

    if (!menuLinks) {
        return;
    }


    for (let i = 0; i < menuLinks.length; i++) {

        if (menuLinks[i].children.length && menuLinks[i].children[0].tagName === 'IMG') {
            // wpml languages menu with images - be careful when switch to svg version
            continue;
        }

        const href = menuLinks[i].getAttribute('href');

        if (href && href.length > 1) { // ignore href with only "#" in href
            menuLinks[i].classList.add('trck2mixp');
            menuLinks[i].setAttribute('data-title', menuLinks[i].textContent);
        }
    }

    const academyPrefix = isAcademyPage ? 'Academy ' : '';
    etoroTracking.track_link('.trck2mixp', academyPrefix + 'Nav Bar - Link Click', function () {
        return {
            LinkTitle: this.getAttribute('data-title'),
        };
    });
}